const print = {
  state: {
    socket: {
      isConnected: false,
      message: '',
      taskId: null
    }
  },
  mutations: {
    SOCKET_ONOPEN(state) {
      state.socket.isConnected = true
    },
    SOCKET_ONCLOSE(state) {
      state.socket.isConnected = false
    },
    SOCKET_ONERROR(state, event) {
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
      state.message = message
    }
  }
}

export default print


// WEBPACK FOOTER //
// ./src/store/modules/print.js